
<style scoped>
  @import '/src/assets/style.css';
</style>
<template>
  <div id="__nuxt">
    <div id="__layout">
      <div style="position: relative">
        <vueHeader :long="long"/>
        <router-view  :long="long" :label="label"/>
        <vueFooter :long="long" :link="link" :label="label"/>
        <vueRight :label="label"/>
        
      </div>
    </div>
  </div>
</template>

<script>
import { BASE_URL } from '@/config';
import axios from 'axios'; // 引入 axios
import vueHeader from '@/components/vueHeader.vue'; 
import vueFooter from '@/components/vueFooter.vue'; 
import vueRight from '@/components/vueRight.vue'; 

export default {
  components: {
    vueHeader,
    vueFooter,
    vueRight,
  },
  data() {
    return {
      long: {},
      label:{},
      link: [],
    }
  },
  mounted() {
    axios.get(`${BASE_URL}index/index/data?lang=vn`).then(res => {
        if (res.data) {
            this.long = res.data.system;
            this.label = res.data.label;
            this.link = res.data.link;
            // 设置首页标题、关键词、描述和ico
            document.title = this.long.title || '首页标题';
            this.setMeta('keywords', this.long.keywords || '首页关键词');
            this.setMeta('description', this.long.description || '首页描述');
            this.setIco(`${BASE_URL}${this.long.ico || '/favicon.ico'}`);
        } else {
          console.error('未获取到有效数据');
        }
      })
      .catch(error => {
        console.error('获取数据失败:', error);
      });
  },
  methods: {
    setMeta(name, content) {
      let meta = document.querySelector(`meta[name="${name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    },
    setIco(href) {
      let link = document.querySelector('link[rel="icon"]');
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'icon');
        document.head.appendChild(link);
      }
      link.setAttribute('href', href);
    }
  }
};
</script>



